import React from 'react';
import classNames from 'classnames';
import styles from './ScrollableContainer.module.scss';

interface Props {
  allowScroll?: boolean;
  style?: React.CSSProperties;
}

export const ScrollableContainer: React.FC<Props> = ({ allowScroll = true, style, children }) => {
  return (
    <div className={classNames(styles.filterContainer, { [styles.scroll]: allowScroll })} style={style}>
      <div className={styles.filterTrack}>{children}</div>
    </div>
  );
};

export default ScrollableContainer;
